module.exports = __webpack_public_path__ + "img/lootbox_button.256d7fac.png";